import styled from 'styled-components'

let ListItem = styled.div`
  position: relative;
  padding: 1rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  background-color: white;

  &:hover {
    background-color: ${props => props.theme.colors.gray50};
  }
`

const LargeText = styled.div`
  color: ${props =>
    props.color ? props.theme.colors[props.color] : props.theme.colors.gray700};
  font-weight: bold;
  font-size: 1.25rem;

  @media only screen and (max-width: 450px) {
    font-size: 1.1rem;
  }
`

const LargeLink = styled.div`
  color: ${props => props.theme.colors.gray700};
  font-weight: bold;
  font-size: 1.25rem;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }

  @media only screen and (max-width: 450px) {
    font-size: 1.1rem;
  }
`

const SubText = styled.div`
  color: ${props => props.theme.colors.gray500};
  font-size: 0.75rem;
`

ListItem.LargeLink = LargeLink
ListItem.LargeText = LargeText
ListItem.SubText = SubText

export default ListItem
